<template>
  <PluginContextMenu
    :id="'add_list_item_' + id"
    ref="el"
    tag="button"
    class="bk-list-item"
    data-element-type="action"
    :menu="menu"
    :data-sortli-id="id"
    :class="[
  {
    'bk-is-disabled': disabled
  },
  'bk-is-' + orientation,
  'bk-is-' + color
]"
  >
    <div class="bk-list-item-inner">
      <div class="bk-list-item-icon">
        <Icon v-if="icon" :name="icon" />
        <ItemIcon v-else-if="bundle" :bundle="bundle" />
      </div>
      <div
        class="bk-list-item-label"
        :class="{
  'bk-tooltip': orientation === 'horizontal' && !ui.isMobile.value
}"
      >
        <span>{{ label }}</span>
      </div>
    </div>

    <div
      class="bk-add-list-drop bk-drop-element"
      :class="['bk-is-' + color, { 'bk-is-dark': isDark }]"
    >
      <div class="bk-add-list-drop-icon">
        <ItemIcon v-if="bundle" :bundle="bundle" />
        <Icon v-else-if="icon" :name="icon" />
      </div>
      <span>{{ label }}</span>
    </div>
  </PluginContextMenu>
</template>

<script setup>
import { useBlokkli, computed, ref } from "#imports";
import { ItemIcon, Icon } from "#blokkli/components";
import { PluginContextMenu } from "#blokkli/plugins";
const { ui, storage, $t } = useBlokkli();
const props = defineProps({
  id: { type: String, required: true },
  label: { type: String, required: true },
  orientation: { type: String, required: true },
  color: { type: String, required: false, default: "default" },
  bundle: { type: String, required: false, default: "" },
  icon: { type: null, required: false, default: void 0 },
  disabled: { type: Boolean, required: false },
  noContextMenu: { type: Boolean, required: false }
});
const el = ref(null);
const favorites = storage.use("blockFavorites", []);
const isFavorite = computed(() => favorites.value.includes(props.id));
const isDark = computed(
  () => props.orientation !== "sidebar" && props.color === "default"
);
const toggleFavorite = () => {
  if (favorites.value.includes(props.id)) {
    favorites.value = favorites.value.filter((v) => v !== props.id);
  } else {
    favorites.value = [...favorites.value, props.id];
  }
};
const menu = computed(() => {
  if (props.noContextMenu) {
    return [];
  }
  return [
    {
      type: "button",
      label: isFavorite.value ? $t("addListItemFavoriteRemove", "Remove from favorites") : $t("addListItemFavoriteAdd", "Add to favorites"),
      icon: isFavorite.value ? "unstar" : "star",
      callback: toggleFavorite
    }
  ];
});
const getElement = () => el.value?.$el;
defineExpose({ getElement });
</script>

<script>
export default {
  name: "AddListItem"
};
</script>
